<template>
  <div>
    <h2 class="mt-1 ml-15 hidden-sm-and-down grey--text">Compra / Cotización</h2> <!-- Full Screen -->
    <h3 class="mt-1 hidden-sm-and-up grey--text">Compra / Cotizacón</h3> <!-- Mobile Screen -->
    <div class="mt-5">
      <v-bottom-navigation :value="value" color="success">
        <v-btn @click="OpenComponent(0)" :disabled="comp0">      
          <span>Compra</span>
          <v-icon>{{CompraIcon}}</v-icon>
        </v-btn>
        <v-btn @click="OpenComponent(1)" :disabled="comp1">
          <span>Cotización</span>
          <v-icon>{{CotizaIcon}}</v-icon>
        </v-btn>
      </v-bottom-navigation>
      <div class="mt-2">
      
          <component v-bind:is="componente" :usu="usu" :contrato="contrato"></component>
      
      </div>
    </div>
    <dialogo :loading="loading"  />
  </div>
</template>
<script>
import axios from 'axios';
import Compra from '@/components/Compra.vue';
import Cotiza from '@/components/Cotiza.vue';
import dialogo from '@/components/dialogo.vue';
export default {
  name: 'Pedidos',
  components: { Compra, Cotiza, dialogo},
  props: ['usu','contrato'],
  data(){
    return{
      loading:false,
      value:null,
      componente:'',
      IconSelect:'check_circle',
      CompraIcon:'monetization_on',
      CotizaIcon:'monetization_on',
      IconDefault:'monetization_on',
      comp0:true,
      comp1:true,
    }
  },
  async mounted(){
    await this.entrada();
  },
   methods:{
    async entrada(){
      this.loading=true;
      const response = await axios.get(process.env.VUE_APP_URL + '/public/api/inv/usuarios/'+ this.contrato +'/'+ this.usu);
      const datos=response.data;
      if (datos[0].existe=='si'){
        if(datos[0].Permiso_3_1!=0) {
          this.comp0=false;
        };
        if(datos[0].Permiso_3_3!=0) {
          this.comp1=false;
        };
      } 
      this.moduloActivo();      
    },
    moduloActivo(){
      if (this.comp0!=true){
          this.componente='Compra';
          this.CompraIcon=this.IconSelect;
          this.CotizaIcon=this.IconDefault;
          this.value=0
      } else {
          if (this.comp1!=true){
            this.componente='Cotiza';
            this.CompraIcon=this.IconDefault;
            this.CotizaIcon=this.IconSelect;
            this.value=1
          } else {
            this.CompraIcon=this.IconDefault;
            this.CotizaIcon=this.IconDefault;
          }
      }
      this.loading=false;
    },
    OpenComponent(value){
      let vComponente;
      switch (value) {
        case 0:
          vComponente='Compra';
          this.CompraIcon=this.IconSelect;
          this.CotizaIcon=this.IconDefault;
          break;
        case 1:
          vComponente='Cotiza';
          this.CompraIcon=this.IconDefault;
          this.CotizaIcon=this.IconSelect;
        break;
      }
      this.componente=vComponente;
    }
  }
}
</script>